"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadImage = void 0;
var loadImage = function (imageUrl) {
    return new Promise(function (resolve, reject) {
        var element = new Image();
        element.addEventListener('load', function () {
            resolve({ imageUrl: imageUrl, imageElement: element });
        });
        element.addEventListener('error', function (error) {
            reject(new Error("Failed to load image ".concat(imageUrl, ": ").concat(error.message)));
        });
        element.crossOrigin = 'anonymous';
        element.src = imageUrl;
    });
};
exports.loadImage = loadImage;
